import { useContext, useEffect } from 'react';

import { TouchpointContactTypeStateContext } from './TouchpointContactTypeContextProvider';

import TouchpointContactTypeData from './TouchpointContactTypeData';

const useTouchpointContactTypeData = () => {
  const [touchpointContactTypeState, setTouchpointContactTypeState] = useContext(TouchpointContactTypeStateContext);

  useEffect(() => {
    if (touchpointContactTypeState.isLoading !== true && touchpointContactTypeState.isLoaded !== true) {
      TouchpointContactTypeData.getTouchpointContactTypes(touchpointContactTypeState, setTouchpointContactTypeState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    touchpointContactTypeState
  };
};

export default useTouchpointContactTypeData;